'use strict';
import { TweenLite, CSSPlugin } from "gsap/all";
const plugins = [CSSPlugin];

export default class ModalFramework {
    constructor() {
        this.name = 'ModalFramework';


        const body = document.querySelector("body");
        let targets = document.querySelectorAll("a[data-modal]");

        if (targets === null || targets.length === 0) {
            return;
        }

        const showModal = (el) => {


            window.dispatchEvent(new CustomEvent('modal.pre.open', {
                detail: {
                    modal: el
                }
            }));


            el.style.display = "block";
            el.style.opacity = 0;
            body.classList.add("openModal");


            TweenLite.to(el, .5, {
                autoAlpha: 1, onComplete: () => {
                    window.dispatchEvent(new CustomEvent('modal.open', {
                        detail: {
                            modal: el
                        }
                    }));
                    el.querySelector(".modalContent").focus();
                }
            });

            el.querySelectorAll("[data-modalclose]").forEach((itm, i) => {
                itm.addEventListener("click", onHideModal);
            });
        };

        const onHideModal = (e) => {

            const trgt = document.querySelector("#" + e.currentTarget.dataset.modalclose);
            window.dispatchEvent(new CustomEvent('modal.preClose', {
                detail: {
                    modal: trgt
                }
            }));

            body.classList.remove("openModal");
            TweenLite.to(trgt, .5, {
                autoAlpha: 0, onComplete: () => {

                    window.dispatchEvent(new CustomEvent('modal.afterClose', {
                        detail: {
                            modal: trgt
                        }
                    }));
                }
            })

            hideModal(trgt);
            e.preventDefault();
        }

        const hideModal = (el) => {


            el.querySelectorAll("[data-modalclose]").forEach((itm, i) => {
                itm.removeEventListener("click", onHideModal);
            });
        };

        const onModalClick = (e) => {
            const modal = document.querySelector("#" + e.currentTarget.dataset.modal);
            if (modal) {
                showModal(modal);
                e.preventDefault();
                return false;
            }
            
        }


        const destroyModals = () => {
            targets = document.querySelectorAll("a[data-modal]");
            targets.forEach((element, i) => {
                element.removeEventListener("click", onModalClick);
            });
        }

        const initModals = () => {
            destroyModals();

            targets = document.querySelectorAll("a[data-modal]");
            targets.forEach((element, i) => {
                element.addEventListener("click", onModalClick);
            });

            d.querySelectorAll(".modal .modalContent").forEach((item) => {
                item.setAttribute("tabindex", "0");

            });

            d.querySelectorAll(".modal .closeBtn").forEach((item) => {
                item.setAttribute("tabindex", "0");

            });

            d.querySelector("body").addEventListener('keyup', (e) => {

                if (e.key && e.key.toLowerCase() === "escape" && d.querySelector("body.openModal")) {
                    d.querySelectorAll(".modal .closeBtn").forEach((input) => {
                        var event = new MouseEvent('click', {
                            view: window,
                            bubbles: true,
                            cancelable: true
                        });
                        input.dispatchEvent(event);
                    });
                }

            });
        };


        initModals();

        window.addEventListener("init-modals", (e) => {
            initModals();
        });
    }
}